import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { DeleteTenderDocumentMutationRequest, DeleteTenderDocumentMutationResponse, DeleteTenderDocumentQueryParams, DeleteTenderDocument400, DeleteTenderDocument401, DeleteTenderDocument403, DeleteTenderDocument422, DeleteTenderDocument429, DeleteTenderDocument500 } from "../types/DeleteTenderDocument";

/**
 * @link /api/purchase-tenders/private/v1/tender/do_delete-documents
 */

export function useDeleteTenderDocument <TData = DeleteTenderDocumentMutationResponse, TError = DeleteTenderDocument400 | DeleteTenderDocument401 | DeleteTenderDocument403 | DeleteTenderDocument422 | DeleteTenderDocument429 | DeleteTenderDocument500, TVariables = DeleteTenderDocumentMutationRequest>(params: DeleteTenderDocumentQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "delete",
        url: `/api/purchase-tenders/private/v1/tender/do_delete-documents`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
